
export const projectSummary = {
  totalDuration: '42개월',
  startDate: '2025.01',
  endDate: '2028.06',
  totalBudget: '2,813억원',
  totalRevenue: '5,440억원',
  totalTasks: 48,
  completedTasks: 4,
  inProgressTasks: 6,
  pendingTasks: 38,
};

export const phases = [
  {
    id: 'phase-land',
    phase: '1단계',
    title: '토지 매입 및 권리 정비',
    period: '2025.01 ~ 2025.09',
    startMonth: 0,
    endMonth: 8,
    color: 'rose',
    icon: 'ri-landscape-line',
    budget: '1,183억원',
    progress: 15,
    status: 'in-progress' as const,
    description: '8개 필지 매입 협상, 소유권 통합, 토양오염 정화',
    milestones: [
      { name: '토양조사 완료', month: 1, done: true },
      { name: '자투리 필지 확보', month: 3, done: true },
      { name: '중앙부 클러스터 협상 타결', month: 5, done: false },
      { name: '합필 등기 완료', month: 8, done: false },
    ],
    tasks: [
      { name: '1302-18, 19번지 (자투리) 매입', start: 0, duration: 2, status: 'completed' as const, dept: '사업팀' },
      { name: '1302번지 (주유소) 매입 협상', start: 0, duration: 4, status: 'in-progress' as const, dept: '사업팀' },
      { name: '토양오염 정밀조사', start: 0, duration: 2, status: 'completed' as const, dept: '환경팀' },
      { name: '1302-2, 3, 13번지 투자자 협상', start: 1, duration: 5, status: 'in-progress' as const, dept: '사업팀' },
      { name: '1302-1번지 구분소유자 협의', start: 2, duration: 6, status: 'in-progress' as const, dept: '법무팀' },
      { name: '집합건물 대지권 해체 절차', start: 3, duration: 5, status: 'pending' as const, dept: '법무팀' },
      { name: '토양정화 이행 (1302)', start: 2, duration: 5, status: 'pending' as const, dept: '환경팀' },
      { name: '합필 등기 신청 및 처리', start: 6, duration: 3, status: 'pending' as const, dept: '법무팀' },
    ],
  },
  {
    id: 'phase-permit',
    phase: '2단계',
    title: '인허가 및 설계',
    period: '2025.04 ~ 2026.02',
    startMonth: 3,
    endMonth: 13,
    color: 'amber',
    icon: 'ri-file-list-3-line',
    budget: '245억원',
    progress: 0,
    status: 'pending' as const,
    description: '건축심의, 환경영향평가, 교통영향평가, 건축허가 취득',
    milestones: [
      { name: '건축심의 통과', month: 8, done: false },
      { name: '환경영향평가 승인', month: 9, done: false },
      { name: '건축허가 취득', month: 12, done: false },
    ],
    tasks: [
      { name: '건축심의 사전검토 신청', start: 3, duration: 2, status: 'pending' as const, dept: '설계팀' },
      { name: '환경영향평가서 작성·제출', start: 4, duration: 5, status: 'pending' as const, dept: '환경팀' },
      { name: '교통영향평가서 제출', start: 5, duration: 3, status: 'pending' as const, dept: '설계팀' },
      { name: '건축위원회 심의', start: 7, duration: 2, status: 'pending' as const, dept: '설계팀' },
      { name: '공공기여 시설 협의 (3-4F)', start: 8, duration: 3, status: 'pending' as const, dept: '사업팀' },
      { name: '건축허가 신청 및 취득', start: 10, duration: 3, status: 'pending' as const, dept: '법무팀' },
      { name: '실시설계 완료', start: 9, duration: 4, status: 'pending' as const, dept: '설계팀' },
    ],
  },
  {
    id: 'phase-presale',
    phase: '3단계',
    title: '착공 준비 및 분양',
    period: '2025.12 ~ 2026.06',
    startMonth: 11,
    endMonth: 17,
    color: 'teal',
    icon: 'ri-hammer-line',
    budget: '398억원',
    progress: 0,
    status: 'pending' as const,
    description: '사업계획 승인, 분양 신고, PF 조달, 착공',
    milestones: [
      { name: '사업계획 승인', month: 13, done: false },
      { name: '분양 개시', month: 15, done: false },
      { name: '착공', month: 17, done: false },
    ],
    tasks: [
      { name: '사업계획 승인 신청', start: 11, duration: 3, status: 'pending' as const, dept: '사업팀' },
      { name: 'PF 대출 약정 체결', start: 12, duration: 3, status: 'pending' as const, dept: '재무팀' },
      { name: '시공사 도급계약 체결', start: 13, duration: 2, status: 'pending' as const, dept: '사업팀' },
      { name: '분양 신고 및 승인', start: 14, duration: 2, status: 'pending' as const, dept: '사업팀' },
      { name: '모델하우스 오픈 & 1차 분양', start: 15, duration: 2, status: 'pending' as const, dept: '마케팅팀' },
      { name: '착공 신고', start: 17, duration: 1, status: 'pending' as const, dept: '설계팀' },
    ],
  },
  {
    id: 'phase-construction',
    phase: '4단계',
    title: '본공사 시공',
    period: '2026.06 ~ 2028.02',
    startMonth: 17,
    endMonth: 37,
    color: 'emerald',
    icon: 'ri-building-2-line',
    budget: '892억원',
    progress: 0,
    status: 'pending' as const,
    description: '기초공사, 골조, 마감, 설비, 조경 등 본공사 진행',
    milestones: [
      { name: '기초공사 완료', month: 21, done: false },
      { name: '골조 완료 (중간검사)', month: 28, done: false },
      { name: '마감공사 완료', month: 35, done: false },
    ],
    tasks: [
      { name: '가설공사 및 터파기', start: 17, duration: 3, status: 'pending' as const, dept: '시공팀' },
      { name: '기초 및 지하구조물 공사', start: 19, duration: 4, status: 'pending' as const, dept: '시공팀' },
      { name: '골조공사 (지상층)', start: 23, duration: 6, status: 'pending' as const, dept: '시공팀' },
      { name: '중간검사 (구조체 완료)', start: 28, duration: 1, status: 'pending' as const, dept: '설계팀' },
      { name: '외장 마감 및 커튼월', start: 27, duration: 5, status: 'pending' as const, dept: '시공팀' },
      { name: 'MEP 설비 공사', start: 25, duration: 8, status: 'pending' as const, dept: '설비팀' },
      { name: '스마트홈 시스템 설치', start: 30, duration: 5, status: 'pending' as const, dept: '설비팀' },
      { name: '내부 마감공사', start: 30, duration: 6, status: 'pending' as const, dept: '시공팀' },
      { name: '조경 및 외부공사', start: 33, duration: 4, status: 'pending' as const, dept: '시공팀' },
      { name: '정기 안전점검 (분기별)', start: 17, duration: 20, status: 'pending' as const, dept: '안전팀' },
    ],
  },
  {
    id: 'phase-completion',
    phase: '5단계',
    title: '준공 및 입주',
    period: '2028.02 ~ 2028.06',
    startMonth: 37,
    endMonth: 41,
    color: 'cyan',
    icon: 'ri-home-heart-line',
    budget: '95억원',
    progress: 0,
    status: 'pending' as const,
    description: '소방검사, 사용승인, 입주, 상업시설 오픈',
    milestones: [
      { name: '소방 완공검사', month: 38, done: false },
      { name: '사용승인 취득', month: 40, done: false },
      { name: '입주 개시', month: 41, done: false },
    ],
    tasks: [
      { name: '소방시설 완공검사', start: 37, duration: 2, status: 'pending' as const, dept: '설계팀' },
      { name: '에너지 효율 등급 인증', start: 37, duration: 2, status: 'pending' as const, dept: '환경팀' },
      { name: '사용승인 (준공검사)', start: 38, duration: 2, status: 'pending' as const, dept: '법무팀' },
      { name: '하자보수 점검', start: 39, duration: 2, status: 'pending' as const, dept: '시공팀' },
      { name: '입주 및 잔금 수납', start: 40, duration: 2, status: 'pending' as const, dept: '사업팀' },
      { name: '상업시설 오픈', start: 41, duration: 1, status: 'pending' as const, dept: '사업팀' },
    ],
  },
];

export const allMonths = [
  '25.01','25.02','25.03','25.04','25.05','25.06','25.07','25.08','25.09','25.10','25.11','25.12',
  '26.01','26.02','26.03','26.04','26.05','26.06','26.07','26.08','26.09','26.10','26.11','26.12',
  '27.01','27.02','27.03','27.04','27.05','27.06','27.07','27.08','27.09','27.10','27.11','27.12',
  '28.01','28.02','28.03','28.04','28.05','28.06',
];

export const keyRisks = [
  {
    title: '토지 매입 지연',
    impact: '최대 6개월',
    probability: '높음',
    severity: 'high',
    mitigation: '매도청구권 법적 토대 구축, SPC 주주 참여 제안, 단계별 매입 전략 수립',
    icon: 'ri-landscape-line',
  },
  {
    title: '인허가 지연',
    impact: '최대 4개월',
    probability: '중간',
    severity: 'medium',
    mitigation: '사전검토 강화, 건축위원회 사전 협의, 환경영향평가 조기 착수',
    icon: 'ri-file-list-3-line',
  },
  {
    title: '공사비 상승',
    impact: '+150억원',
    probability: '중간',
    severity: 'medium',
    mitigation: '도급계약 물가변동 조항 제한, 예비비 5% 확보, VE 설계 적용',
    icon: 'ri-money-dollar-circle-line',
  },
  {
    title: '분양률 저하',
    impact: 'IRR 5%p 하락',
    probability: '낮음',
    severity: 'low',
    mitigation: '하이엔드 차별화 전략, 조기 분양 마케팅, 임대 전환 옵션 확보',
    icon: 'ri-home-line',
  },
  {
    title: '금리 변동',
    impact: '±26억원/1%p',
    probability: '중간',
    severity: 'medium',
    mitigation: '고정금리 PF 확보, 분양 선수금 조기 확보, 시공사 책임준공 확약',
    icon: 'ri-percent-line',
  },
  {
    title: '토양정화 범위 확대',
    impact: '+30~50억원',
    probability: '중간',
    severity: 'medium',
    mitigation: '정밀조사 기반 정화 범위 확정, 매매대금 사전 공제 특약 구조',
    icon: 'ri-leaf-line',
  },
];

export const cashFlowData = [
  { year: '2025', quarter: 'Q1', cost: -380, revenue: 0, cumulative: -380 },
  { year: '2025', quarter: 'Q2', cost: -820, revenue: 0, cumulative: -1200 },
  { year: '2025', quarter: 'Q3', cost: -650, revenue: 0, cumulative: -1850 },
  { year: '2025', quarter: 'Q4', cost: -420, revenue: 0, cumulative: -2270 },
  { year: '2026', quarter: 'Q1', cost: -580, revenue: 0, cumulative: -2850 },
  { year: '2026', quarter: 'Q2', cost: -380, revenue: 4200, cumulative: 970 },
  { year: '2026', quarter: 'Q3', cost: -620, revenue: 800, cumulative: 1150 },
  { year: '2026', quarter: 'Q4', cost: -680, revenue: 800, cumulative: 1270 },
  { year: '2027', quarter: 'Q1', cost: -720, revenue: 800, cumulative: 1350 },
  { year: '2027', quarter: 'Q2', cost: -680, revenue: 800, cumulative: 1470 },
  { year: '2027', quarter: 'Q3', cost: -620, revenue: 800, cumulative: 1650 },
  { year: '2027', quarter: 'Q4', cost: -580, revenue: 800, cumulative: 1870 },
  { year: '2028', quarter: 'Q1', cost: -480, revenue: 1200, cumulative: 2590 },
  { year: '2028', quarter: 'Q2', cost: -146, revenue: 1832, cumulative: 4276 },
];

export const officetelTypes = {
  buildingA: {
    name: 'A동',
    totalUnits: 156,
    totalRevenue: '3,458억원',
    avgPricePerPyeong: '1.35억원',
    types: [
      {
        type: 'A-1',
        exclusiveArea: '29.70㎡',
        supplyArea: '42.15㎡',
        pyeong: '12.7평',
        units: 24,
        floorRange: '5~10F',
        pricePerPyeong: '1.28억',
        unitPrice: '16.3억',
        totalRevenue: '391억',
        features: '1인 프리미엄 스튜디오',
      },
      {
        type: 'A-2',
        exclusiveArea: '39.60㎡',
        supplyArea: '56.20㎡',
        pyeong: '17.0평',
        units: 36,
        floorRange: '5~15F',
        pricePerPyeong: '1.32억',
        unitPrice: '22.4억',
        totalRevenue: '806억',
        features: '1.5룸 컴팩트 타입',
      },
      {
        type: 'A-3',
        exclusiveArea: '49.50㎡',
        supplyArea: '70.25㎡',
        pyeong: '21.2평',
        units: 42,
        floorRange: '8~20F',
        pricePerPyeong: '1.38억',
        unitPrice: '29.3억',
        totalRevenue: '1,231억',
        features: '2룸 스탠다드 타입',
      },
      {
        type: 'A-4',
        exclusiveArea: '66.00㎡',
        supplyArea: '93.70㎡',
        pyeong: '28.3평',
        units: 30,
        floorRange: '15~25F',
        pricePerPyeong: '1.42억',
        unitPrice: '40.2억',
        totalRevenue: '1,206억',
        features: '2룸 프리미엄 타입',
      },
      {
        type: 'A-PH',
        exclusiveArea: '99.00㎡',
        supplyArea: '140.55㎡',
        pyeong: '42.5평',
        units: 24,
        floorRange: '26~30F',
        pricePerPyeong: '1.50억',
        unitPrice: '63.8억',
        totalRevenue: '1,531억',
        features: '펜트하우스 / 테라스',
      },
    ],
  },
  buildingB: {
    name: 'B동',
    totalUnits: 155,
    totalRevenue: '3,459억원',
    avgPricePerPyeong: '1.35억원',
    types: [
      {
        type: 'B-1',
        exclusiveArea: '29.70㎡',
        supplyArea: '42.15㎡',
        pyeong: '12.7평',
        units: 22,
        floorRange: '5~10F',
        pricePerPyeong: '1.28억',
        unitPrice: '16.3억',
        totalRevenue: '359억',
        features: '1인 프리미엄 스튜디오',
      },
      {
        type: 'B-2',
        exclusiveArea: '39.60㎡',
        supplyArea: '56.20㎡',
        pyeong: '17.0평',
        units: 35,
        floorRange: '5~15F',
        pricePerPyeong: '1.32억',
        unitPrice: '22.4억',
        totalRevenue: '784억',
        features: '1.5룸 컴팩트 타입',
      },
      {
        type: 'B-3',
        exclusiveArea: '49.50㎡',
        supplyArea: '70.25㎡',
        pyeong: '21.2평',
        units: 44,
        floorRange: '8~20F',
        pricePerPyeong: '1.38억',
        unitPrice: '29.3억',
        totalRevenue: '1,289억',
        features: '2룸 스탠다드 타입',
      },
      {
        type: 'B-4',
        exclusiveArea: '66.00㎡',
        supplyArea: '93.70㎡',
        pyeong: '28.3평',
        units: 30,
        floorRange: '15~25F',
        pricePerPyeong: '1.42억',
        unitPrice: '40.2억',
        totalRevenue: '1,206억',
        features: '2룸 프리미엄 타입',
      },
      {
        type: 'B-PH',
        exclusiveArea: '99.00㎡',
        supplyArea: '140.55㎡',
        pyeong: '42.5평',
        units: 24,
        floorRange: '26~30F',
        pricePerPyeong: '1.50억',
        unitPrice: '63.8억',
        totalRevenue: '1,531억',
        features: '펜트하우스 / 테라스',
      },
    ],
  },
};

export const podiumData = {
  summary: {
    totalArea: '12,450㎡',
    annualRevenue: '164.7억원',
    avgYield: '6.8%',
  },
  floors: [
    {
      floor: 'B1',
      usage: '주차장 및 기계실',
      area: '3,200㎡',
      deposit: '-',
      monthlyRent: '-',
      annualRevenue: '-',
      revenueShare: '0%',
      categories: ['주차 280대', '기계실', '전기실', '방재실'],
      note: '임대 대상 아님 (건물 부대시설)',
      tableNote: '부대시설',
    },
    {
      floor: '1F',
      usage: '프리미엄 리테일 & F&B',
      area: '2,850㎡',
      deposit: '평당 1.2억',
      monthlyRent: '평당 45만원',
      annualRevenue: '46.5억원',
      revenueShare: '28.2%',
      categories: ['백화점/면세점', '프리미엄 F&B', '카페/베이커리', '뷰티/화장품'],
      note: '메인 출입구 및 로비 포함, 천고 6m 이상 확보',
      tableNote: '로비 포함',
    },
    {
      floor: '2F',
      usage: '패션 & 라이프스타일',
      area: '2,400㎡',
      deposit: '평당 1.0억',
      monthlyRent: '평당 38만원',
      annualRevenue: '33.1억원',
      revenueShare: '20.1%',
      categories: ['패션 브랜드', '액세서리', '라이프스타일 편집샵', '스포츠/아웃도어'],
      note: '오피스텔 로비 연결 브릿지',
      tableNote: '브릿지 연결',
    },
    {
      floor: '3F',
      usage: '공공기여 시설 (복합화 센터)',
      area: '1,800㎡',
      deposit: '-',
      monthlyRent: '-',
      annualRevenue: '-',
      revenueShare: '0%',
      categories: ['주민센터 분소', '공공도서관', '커뮤니티 라운지', '다목적 홀'],
      note: '서초구청 무상 기부채납 (용적률 인센티브 35% 확보)',
      tableNote: '기부채납',
    },
    {
      floor: '4F',
      usage: '헬스케어 & 웰니스',
      area: '2,200㎡',
      deposit: '평당 0.8억',
      monthlyRent: '평당 32만원',
      annualRevenue: '25.5억원',
      revenueShare: '15.5%',
      categories: ['피트니스 센터', '필라테스/요가', '메디컬 클리닉', '스파/마사지'],
      note: '오피스텔 입주민 우선 할인 제공',
      tableNote: '입주민 할인',
    },
  ],
};